import {Component, OnInit} from '@angular/core';
import {UserRegiester} from '../registeration/user-registeration';
import {GenOTPRequest} from '../registeration/gen-otp-request';
import {SharedService} from '../shared.service';
import {NGXLogger} from 'ngx-logger';
import {OTPResponse, Otp} from './gen-otp-response';
import {PopUpService} from '../PopUpService';
import {EkpayUserResponse} from '../../user/ekpay_user';
import {LoaderService} from '../../loader/loader.service';
import {DataStorageService} from '../data-storage.service';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-registeration',
  templateUrl: './registeration.component.html',
  styleUrls: ['./registeration.component.css'],
})
export class RegisterationComponent implements OnInit {

  constructor(private sharedService: SharedService,
              private logger: NGXLogger,
              private popupservice: PopUpService,
              private loaderService: LoaderService,
              private dataStorageService: DataStorageService,
              private translate: TranslateService) {
  }

  userRegiester: UserRegiester;
  getotpReq: GenOTPRequest;
  otpResponse: OTPResponse;
  otp: Otp;
  isCapcha: boolean;
  isSeries: boolean = false;
  isUser: boolean = false;
  ekpayUserResponse: EkpayUserResponse;
  image: string;
  captcha: string = '';
  isCaptchaValid: boolean = false;
  isMobile: boolean = false;
  subscription: Subscription;
  lang: string;
  ture: any;
  isCaptchaRequired: boolean;

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem('lang');
      }
      this.logger.debug('data lang is ' + this.lang);
      this.translate.use(this.lang);
    });
    this.userRegiester = new UserRegiester();
    this.userRegiester.username = '';
    this.userRegiester.password = '';
    this.getotpReq = new GenOTPRequest();
    this.isCapcha = false;

    this.sharedService.getCapcha().subscribe(data => {
      this.logger.debug('response....' + data);
      this.image = data;
    });

  }

  refreshCaptcha() {
    this.image = null;
    this.sharedService.getCapcha().subscribe(data => {
      this.logger.debug('response....' + data);
      this.image = data;
    });
  }

  genOTP() {
    this.getotpReq.ekpayId = this.userRegiester.username;
    this.getotpReq.mobile = this.userRegiester.mobile;
    sessionStorage.setItem('getotpReq', JSON.stringify(this.getotpReq));
    sessionStorage.setItem('otpType', 'registration');
    this.getotpReq.ekpayId = 'Reg';
    this.logger.debug('get otp req.....' + JSON.stringify(this.getotpReq));
    this.sharedService.getOTP(this.getotpReq).subscribe((data) => {
      this.logger.debug('calling get otp method....' + JSON.stringify(data));
      this.otpResponse = data.body as OTPResponse;
      if ('success' == this.otpResponse.status) {
        this.popupservice.isEnable = true;
        this.popupservice.isOtp = true;
        this.popupservice.isLogin = false;
        this.popupservice.isRegister = false;
        this.popupservice.title = 'enter-otp';
        sessionStorage.setItem('otp_id', this.otpResponse.otp.otp_id);
        sessionStorage.setItem('otp_response', JSON.stringify(this.userRegiester));
      }
    });
  }

  checkMobileStartingDigit(mobileNo) {
    if (mobileNo.substring(0, 2) == 11 || mobileNo.substring(0, 2) == 13
      || mobileNo.substring(0, 2) == 15 || mobileNo.substring(0, 2) == 16
      || mobileNo.substring(0, 2) == 17 || mobileNo.substring(0, 2) == 18 || mobileNo.substring(0, 2) == 19) {
      this.isSeries = false;
    } else if (mobileNo.length > 0) {
      this.isSeries = true;
    } else {
      this.isSeries = false;
    }
  }

  closeUp() {
    this.popupservice.isRegister = false;
  }

  checkUsernameAvailable() {
    this.logger.debug('calling get user method.....' + this.userRegiester.username);
    if (this.userRegiester.username.length > 1) {
      this.loaderService.show();
      this.sharedService.getUser(this.userRegiester.username).subscribe(data => {
        this.logger.debug('response....' + JSON.stringify(data.body));
        // this.ekpayUserResponse = data.body as EkpayUserResponse;
        if (data.body.status) {
          this.isUser = true;
        } else {
          this.isUser = false;
        }
        this.loaderService.hide();
      });
    }
  }

  checkMobileAvailable() {
    this.logger.debug('calling get user method.....' + this.userRegiester.mobile);
    if (this.userRegiester.mobile.length > 9) {
      this.loaderService.show();
      this.sharedService.getUser(this.userRegiester.mobile).subscribe(data => {
        this.logger.debug('response....' + JSON.stringify(data.body));
        // this.ekpayUserResponse = data.body as EkpayUserResponse;
        if (data.body.status) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
        this.loaderService.hide();
      });
    }
  }

  // verfyCaptch() {
  //   this.logger.debug("validate captcha....")
  //   this.isCaptchaValid = false;
  //   this.sharedService.validateCapcha(this.captcha).subscribe(data => {
  //     this.logger.debug("response...." + JSON.stringify(data));
  //     if (data == "success") {
  //       this.genOTP();
  //     } else {
  //       this.isCaptchaValid = true;
  //     }
  //   });
  // }

  verifyCaptcha() {
    this.logger.debug('validate captcha....');
    if (this.isCaptchaValid) {
      this.genOTP();
    } else {
      this.isCaptchaRequired = true;
    }

  }

  public resolved(captchaResponse: string) {
    this.logger.debug(`Resolved captcha with response: ${captchaResponse}`);
    this.isCaptchaRequired = false;
    if (captchaResponse == null) {
      this.isCaptchaValid = false;
    } else {
      this.isCaptchaValid = true;
    }


  }

}



// WEBPACK FOOTER //
// ./src/app/shared/registeration/registeration.component.ts